"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require("./infra"),
    isASCIIHex = _require.isASCIIHex;

var _require2 = require("./encoding"),
    utf8Encode = _require2.utf8Encode; // https://url.spec.whatwg.org/#percent-encode


function percentEncode(c) {
  var hex = c.toString(16).toUpperCase();

  if (hex.length === 1) {
    hex = "0".concat(hex);
  }

  return "%".concat(hex);
} // https://url.spec.whatwg.org/#percent-decode


function percentDecodeBytes(input) {
  var output = new Uint8Array(input.byteLength);
  var outputIndex = 0;

  for (var i = 0; i < input.byteLength; ++i) {
    var byte = input[i];

    if (byte !== 0x25) {
      output[outputIndex++] = byte;
    } else if (byte === 0x25 && (!isASCIIHex(input[i + 1]) || !isASCIIHex(input[i + 2]))) {
      output[outputIndex++] = byte;
    } else {
      var bytePoint = parseInt(String.fromCodePoint(input[i + 1], input[i + 2]), 16);
      output[outputIndex++] = bytePoint;
      i += 2;
    }
  }

  return output.slice(0, outputIndex);
} // https://url.spec.whatwg.org/#string-percent-decode


function percentDecodeString(input) {
  var bytes = utf8Encode(input);
  return percentDecodeBytes(bytes);
} // https://url.spec.whatwg.org/#c0-control-percent-encode-set


function isC0ControlPercentEncode(c) {
  return c <= 0x1F || c > 0x7E;
} // https://url.spec.whatwg.org/#fragment-percent-encode-set


var extraFragmentPercentEncodeSet = new Set([32, 34, 60, 62, 96]);

function isFragmentPercentEncode(c) {
  return isC0ControlPercentEncode(c) || extraFragmentPercentEncodeSet.has(c);
} // https://url.spec.whatwg.org/#query-percent-encode-set


var extraQueryPercentEncodeSet = new Set([32, 34, 35, 60, 62]);

function isQueryPercentEncode(c) {
  return isC0ControlPercentEncode(c) || extraQueryPercentEncodeSet.has(c);
} // https://url.spec.whatwg.org/#special-query-percent-encode-set


function isSpecialQueryPercentEncode(c) {
  return isQueryPercentEncode(c) || c === 39;
} // https://url.spec.whatwg.org/#path-percent-encode-set


var extraPathPercentEncodeSet = new Set([63, 96, 123, 125]);

function isPathPercentEncode(c) {
  return isQueryPercentEncode(c) || extraPathPercentEncodeSet.has(c);
} // https://url.spec.whatwg.org/#userinfo-percent-encode-set


var extraUserinfoPercentEncodeSet = new Set([47, 58, 59, 61, 64, 91, 92, 93, 94, 124]);

function isUserinfoPercentEncode(c) {
  return isPathPercentEncode(c) || extraUserinfoPercentEncodeSet.has(c);
} // https://url.spec.whatwg.org/#component-percent-encode-set


var extraComponentPercentEncodeSet = new Set([36, 37, 38, 43, 44]);

function isComponentPercentEncode(c) {
  return isUserinfoPercentEncode(c) || extraComponentPercentEncodeSet.has(c);
} // https://url.spec.whatwg.org/#application-x-www-form-urlencoded-percent-encode-set


var extraURLEncodedPercentEncodeSet = new Set([33, 39, 40, 41, 126]);

function isURLEncodedPercentEncode(c) {
  return isComponentPercentEncode(c) || extraURLEncodedPercentEncodeSet.has(c);
} // https://url.spec.whatwg.org/#code-point-percent-encode-after-encoding
// https://url.spec.whatwg.org/#utf-8-percent-encode
// Assuming encoding is always utf-8 allows us to trim one of the logic branches. TODO: support encoding.
// The "-Internal" variant here has code points as JS strings. The external version used by other files has code points
// as JS numbers, like the rest of the codebase.


function utf8PercentEncodeCodePointInternal(codePoint, percentEncodePredicate) {
  var bytes = utf8Encode(codePoint);
  var output = "";

  var _iterator = _createForOfIteratorHelper(bytes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var byte = _step.value;

      // Our percentEncodePredicate operates on bytes, not code points, so this is slightly different from the spec.
      if (!percentEncodePredicate(byte)) {
        output += String.fromCharCode(byte);
      } else {
        output += percentEncode(byte);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return output;
}

function utf8PercentEncodeCodePoint(codePoint, percentEncodePredicate) {
  return utf8PercentEncodeCodePointInternal(String.fromCodePoint(codePoint), percentEncodePredicate);
} // https://url.spec.whatwg.org/#string-percent-encode-after-encoding
// https://url.spec.whatwg.org/#string-utf-8-percent-encode


function utf8PercentEncodeString(input, percentEncodePredicate) {
  var spaceAsPlus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var output = "";

  var _iterator2 = _createForOfIteratorHelper(input),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var codePoint = _step2.value;

      if (spaceAsPlus && codePoint === " ") {
        output += "+";
      } else {
        output += utf8PercentEncodeCodePointInternal(codePoint, percentEncodePredicate);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return output;
}

module.exports = {
  isC0ControlPercentEncode: isC0ControlPercentEncode,
  isFragmentPercentEncode: isFragmentPercentEncode,
  isQueryPercentEncode: isQueryPercentEncode,
  isSpecialQueryPercentEncode: isSpecialQueryPercentEncode,
  isPathPercentEncode: isPathPercentEncode,
  isUserinfoPercentEncode: isUserinfoPercentEncode,
  isURLEncodedPercentEncode: isURLEncodedPercentEncode,
  percentDecodeString: percentDecodeString,
  percentDecodeBytes: percentDecodeBytes,
  utf8PercentEncodeString: utf8PercentEncodeString,
  utf8PercentEncodeCodePoint: utf8PercentEncodeCodePoint
};